/* eslint-disable no-useless-catch */

import axios, { AxiosRequestConfig, } from 'axios';
import { ReviewRatingAwardResponse, } from '../types';
import config from '../config/common';
import { DEFAULT_TIMEOUT, } from '../../sew-widget/components/Constants';

export async function getRraDataByVehicleId(apiKey: string, vehicleId: string, panels: string, clientId: string, noCache = false): Promise<ReviewRatingAwardResponse> {
  const apiUrl = `${config.baseUrl}/api/getdatabykbbvehicleid`;
  const params = {
    apiKey,
    vehicleId,
    panels,
    noCache,
    clientId,
  };
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: apiUrl,
    params,
    timeout: DEFAULT_TIMEOUT,
  };
  if (noCache) {
    axiosConfig.headers = { 'Cache-Control': 'no-cache', };
  }
  try {
    const response = await axios.request(axiosConfig);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getRraDataByVin(apiKey: string, vin: string, vehicleclass: string, panels: string, clientId: string, noCache = false): Promise<ReviewRatingAwardResponse> {
  const apiUrl = `${config.baseUrl}/api/getdatabyvin`;
  const params = {
    apiKey,
    vin,
    vehicleclass,
    panels,
    noCache,
    clientId,
  };
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: apiUrl,
    params,
    timeout: DEFAULT_TIMEOUT,
  };
  if (noCache) {
    axiosConfig.headers = { 'Cache-Control': 'no-cache', };
  }
  try {
    const response = await axios.request(axiosConfig);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getRraDataByText(apiKey: string, year: string, make: string, model: string, panels: string, clientId: string, noCache = false): Promise<ReviewRatingAwardResponse> {
  
  const apiUrl = `${config.baseUrl}/api/getdatabytext`;
  const params = {
    apiKey,
    year,
    makeName: make,
    modelName: model,
    panels,
    noCache,
    clientId,
  };
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: apiUrl,
    params,
    timeout: DEFAULT_TIMEOUT,
  };
  if (noCache) {
    axiosConfig.headers = { 'Cache-Control': 'no-cache', };
  }
  try {
    const response = await axios.request(axiosConfig);
    return response.data;
  } catch (error) {
    throw error;
  }
}
